import { pageResolver } from '@/core/component-resolver.service';
import FallbackPage from './FallbackPage.vue';

// Fallback
pageResolver.registerFallback(FallbackPage);
